const clearTrackerCacheObjects = (client) => {
  const serializedState = client.cache.extract();
  const trackerListKeys = Object.keys(serializedState).filter((item) =>
    item.includes('DailyTrackerData')
  );

  trackerListKeys.forEach((key) => {
    client.cache.evict({
      id: key,
    });
  });

  client.cache.gc();
};

export default clearTrackerCacheObjects;
